import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Endpoints that are polled by the app (auto-refresh, notifications, session
// probe) — they must NOT extend the idle session. Everything else counts as a
// deliberate user action unless the call explicitly opts out via `config.meta.polling`.
const POLLING_PATHS = [
  "/auth/session",       // silent session probe
  "/tickets/stats",      // Dashboard auto-refresh 30s
  "/notifications",      // NotificationBell polling 30s
  "/stats/technicians",  // Dashboard leaderboard
  "/system/time",        // WIB server time bootstrap
];

function isPollingRequest(config) {
  if (config?.meta?.polling) return true;
  const path = (config?.url || "").split("?")[0];
  return POLLING_PATHS.some((p) => path === p || path.endsWith(p));
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback (samesite=none cookies may be blocked in some browsers)
// AND flag the request as human activity unless it's a background poll.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aroma_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (!isPollingRequest(config)) {
    config.headers["X-User-Activity"] = "1";
  }
  return config;
});

// Detect server-side session expiry and let the app respond globally.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 401 && typeof detail === "string" &&
        ["SESSION_IDLE", "SESSION_EXPIRED", "SESSION_REVOKED"].includes(detail)) {
      try { localStorage.removeItem("aroma_token"); } catch {}
      window.dispatchEvent(new CustomEvent("session-expired", { detail: { reason: detail } }));
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
